import React, { useState, useEffect,useImperativeHandle, forwardRef } from 'react';

const CanvasPreviewImage = ({ src, fallbackSrc, size }) => {
  const [hasError, setHasError] = useState(false);

  return (
    <div className="preview-image-flex">
      <img
        className={"preview-image preview-image--" + size}
        src={hasError ? fallbackSrc : src}
        onError={() => setHasError(true)}
        alt=""
      />
      {hasError && <div className="preview-image-error"></div>}
    </div>
  );
};

export default CanvasPreviewImage;